export default __webpack_public_path__ + "static/media/plus-icon.b1211638.svg";